import debounce from 'lodash.debounce'
export const debouncedSet = debounce((val, setState) => {
	setState(val)
}, 1000)
export const debouncedSearch = debounce((val, fn) => {
	fn(val)
}, 1000)
